import { debugLog } from '../utils/debugUtils';

export const initSentry = () => {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn || process.env.NODE_ENV !== 'production') {
    debugLog('[SentryService] Sentry disabled (not production or no DSN)');
    return;
  }

  try {
    // @sentry/capacitor@3.x + @sentry/react@10.x API
    Promise.all([import('@sentry/react'), import('@sentry/capacitor')]).then(
      ([SentryReact, SentryCapacitor]) => {
        SentryCapacitor.init(
          {
            dsn,
            integrations: [SentryReact.browserTracingIntegration()],
            tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
            release: `concordare@${process.env.REACT_APP_VERSION}`,
            environment: process.env.NODE_ENV,
            sendDefaultPii: true,
          },
          SentryReact.init
        );
        debugLog('[SentryService] Sentry initialized');
      }
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[SentryService] Failed to initialize Sentry:', err);
  }
};
